<template>
  <header
    class="itb-lazy-loading-bg"
    v-bind:class="{ 'itb-element-header': !showElement }"
    v-lazy:background-image="
      !videoUrl && params.page_header_image
        ? '/uploads/' + params.page_header_image
        : null
    "
  >
    <video-background
      v-if="videoUrl"
      :src="videoUrl"
      :poster="videoPoster"
    ></video-background>

    <div
      class="d-flex flex-column h-100"
      style="z-index: 2; position: relative"
    >
      <nav
        class="navbar navbar-expand-lg navbar-dark p-0 fixed-top"
        id="itb-navbar"
      >
        <div class="container">
          <div class="itb-container-under-md" id="itb-navbar-header">
            <a class="navbar-brand" href="/">
              <img
                src="/images/logo.png"
                :alt="$t('general.4soft_logo_link')"
              />
            </a>
            <button
              class="navbar-toggler collapsed"
              type="button"
              data-toggle="collapse"
              data-target="#navbarCollapse"
              aria-controls="navbarCollapse"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span class="navbar-toggler-icon"></span>
            </button>
          </div>
          <div
            class="itb-container-under-md ml-md-auto"
            id="itb-navbar-wrapper"
          >
            <div class="navbar-collapse collapse" id="navbarCollapse">
              <ul class="navbar-nav ml-auto">
                <li class="nav-item" @click="closeNavbar">
                  <router-link
                    class="nav-link"
                    :class="{
                      'router-link-exact-active': subIsActive([
                        '/nase-nabidka',
                        '/dopadove-plochy',
                        '/herni-plochy',
                        '/3d-hriste',
                        '/mlhoviste',
                        '/sportoviste',
                        '/trampoliny',
                      ]),
                    }"
                    :to="{ name: 'home' }"
                    >{{ $t("title.our_offer") }}</router-link
                  >
                </li>
                <li class="nav-item" @click="closeNavbar">
                  <router-link
                    class="nav-link"
                    :class="{
                      'router-link-exact-active': subIsActive('/grafika'),
                    }"
                    :to="{ name: 'graphics' }"
                    >{{ $t("title.graphics") }}</router-link
                  >
                </li>
                <li class="nav-item" @click="closeNavbar">
                  <router-link class="nav-link" :to="{ name: 'epdm' }"
                    >SmartSoft®</router-link
                  >
                </li>
                <li class="nav-item" @click="closeNavbar">
                  <router-link
                    class="nav-link"
                    :class="{
                      'router-link-exact-active': subIsActive([
                        '/detail-realizace',
                        '/prehled-realizaci',
                      ]),
                    }"
                    :to="{ name: 'realizations' }"
                    >{{ $t("title.realizations") }}</router-link
                  >
                </li>
                <li class="nav-item" @click="closeNavbar">
                  <router-link class="nav-link" :to="{ name: 'aboutus' }">{{
                    $t("title.about_us")
                  }}</router-link>
                </li>
                <li class="nav-item" @click="closeNavbar">
                  <router-link class="nav-link" :to="{ name: 'contact' }">{{
                    $t("title.contacts")
                  }}</router-link>
                </li>
                <li class="nav-item itb-link-separator" @click="closeNavbar">
                  <router-link class="nav-link" :to="{ name: 'download' }">
                    {{ $t("title.download") }}
                    <img
                      src="/images/icons/4soft_icon_download.svg"
                      :alt="$t('general.download_link')"
                      class="itb-icon itb-download-icon"
                    />
                  </router-link>
                </li>
                <li class="nav-item" @click="closeNavbar">
                  <router-link class="nav-link" :to="{ name: 'careers' }">{{
                    $t("title.career")
                  }}</router-link>
                </li>
                <li class="nav-item d-flex align-items-center" @click="closeNavbar">
                
                <a
                    class="nav-link itb-instagram-link-youtube"
                    href="https://www.youtube.com/@michalkubin5692"
                    target="_blank"
                  >
                    <img
                      src="/images/icons/youtube_logo.png"
                      alt="youtube-link"
                      class="itb-icon itb-instagram-icon"
                    />
                  </a>
                  <a
                    class="nav-link itb-instagram-link-instagram"
                    :href="appParams.general_instagram"
                    target="_blank"
                  >
                    <img
                      src="/images/icons/instagram_logo.png"
                      :alt="$t('general.instagram_link')"
                      class="itb-icon itb-instagram-icon"
                    />
                  </a>
                
                
                </li>
                <li class="nav-item itb-link-separator" @click="closeNavbar">
                  <a
                    class="nav-link"
                    href="https://epdm-graphics.com"
                    target="_blank"
                    style="background: #0075b0; border-radius: 4px"
                  >
                    <span>EN/FR</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </nav>
      <div class="text-center" id="itb-hero" v-if="showElement">
        <h1 v-html="params.page_title"></h1>
        <p
          v-if="$route.name == 'careers' || $route.name == 'careerDetail'"
          class="itb-h1-subtitle"
        >
          {{ params.page_subtitle }}
        </p>
        <p v-else class="itb-h1-subtitle"></p>
        <button
          class="btn btn-primary itb-btn-double-icon"
          @click="scrollToElement('itb-page-content')"
          v-if="$route.name != 'home'"
        >
          <img
            src="/images/icons/4soft_icon_angle-down.svg"
            :alt="params.page_header_button_text"
            class="itb-icon itb-angle-down-icon"
          />
          {{ params.page_button_text }}
          <img
            src="/images/icons/4soft_icon_angle-down.svg"
            :alt="params.headerButtonLabel"
            class="itb-icon itb-angle-down-icon"
          />
        </button>
        <div
          class="itb-catalogue-link-wrapper d-flex justify-content-center align-items-center"
          v-else
        >
          <div
            class="d-flex justify-content-center align-items-center"
            :class="{ 'flex-column': isResponsive }"
          >
            <div
              class="d-flex flex-column justify-content-center align-items-center"
            >
              <span id="itb-new-catalogue-text-1">{{
                appParams.general_catalogue_title
              }}</span
              ><span id="itb-new-catalogue-text-2">{{
                appParams.general_catalogue_year
              }}</span>
            </div>
            <img
              src="/images/catalogue-thumbnail.webp"
              :alt="params.headerButtonLabel"
              class="itb-catalogue-thumbnail"
              v-if="!isResponsive"
            />
            <button type="button" @click="showCatalogue">
              <span style="font-size: 1.4rem; font-weight: 900">{{
                $t("general.browse")
              }}</span>
            </button>
          </div>
          <img
            src="/images/catalogue-thumbnail.webp"
            :alt="params.headerButtonLabel"
            class="itb-catalogue-thumbnail"
            v-if="isResponsive"
          />
        </div>
      </div>
      <div
        class="d-flex align-items-center mx-auto mt-auto"
        id="itb-achievements"
        v-if="showElement"
        :class="
          params.page_is_on_references
            ? 'itb-long'
            : '' + params.achievementClass
            ? params.achievementClass
            : ''
        "
      >
        <div class="d-flex align-items-center mx-auto">
          <span class="itb-number ml-0">{{
            params.page_blue_bar_number_1
          }}</span>
          <span v-html="params.page_blue_bar_text_1"></span>
        </div>

        <div class="d-flex align-items-center mx-auto">
          <span class="itb-number">{{ params.page_blue_bar_number_2 }}</span>
          <span v-html="params.page_blue_bar_text_2"></span>
        </div>
        <div
          class="itb-reference d-flex ml-auto"
          v-if="params.page_is_on_references"
        >
          <div class="d-inline-block">
            <button class="btn btn-link itb-prev">
              <img
                src="/images/icons/4soft_icon_nav-left.svg"
                :alt="$t('general.prev_reference')"
                class="itb-icon"
              />
            </button>
            <button class="btn btn-link itb-next">
              <img
                src="/images/icons/4soft_icon_nav-right.svg"
                :alt="$t('general.next_reference')"
                class="itb-icon"
              />
            </button>
          </div>
          <div class="d-inline-block">
            <span>Hřiště v Horní Dolní</span>
            <br />
            <a href="#">{{ $t("general.show_realization") }}</a>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      path: null,
      isResponsive: false,
    };
  },

  computed: {
    ...mapGetters({
      appParams: "getAppParams",
      params: "getPageParams",
    }),

    videoUrl() {
      if (this.$route.path == "/") {
        return "/uploads/homepage.mp4";
      } else if (this.$route.path == "/dopadove-plochy") {
        return "/uploads/dopadove-plochy.mp4";
      } else if (this.$route.path == "/herni-plochy") {
        return "/uploads/herni-plochy.mp4";
      } else if (this.$route.path == "/3d-hriste") {
        return "/uploads/3d-hriste.mp4";
      } else if (this.$route.path == "/mlhoviste") {
        return "/uploads/mlhoviste.mp4";
      } else if (this.$route.path == "/cisteni") {
        return "/uploads/cisteni.mp4";
      } else if (this.$route.path == "/sportoviste") {
        return "/uploads/sportoviste.mp4";
      }

      return false;
    },

    videoPoster() {
      if (this.$route.path == "/") {
        return "/images/articles/homepage-poster.webp";
      } else if (this.$route.path == "/dopadove-plochy") {
        return "/images/articles/dopadove-plochy-poster.webp";
      } else if (this.$route.path == "/herni-plochy") {
        return "/images/articles/herni-plochy-poster.webp";
      } else if (this.$route.path == "/3d-hriste") {
        return "/images/articles/3d-hriste-poster.webp";
      } else if (this.$route.path == "/mlhoviste") {
        return "/images/articles/mlhoviste-poster.webp";
      } else if (this.$route.path == "/trampoliny") {
        return "/images/articles/trampoliny-poster.webp";
      } else if (this.$route.path == "/cisteni") {
        return "/images/articles/cisteni-poster.webp";
      } else if (this.$route.path == "/sportoviste") {
        return "/images/articles/sportoviste-poster.webp";
      }

      return false;
    },
    showElement() {
      if (
        this.$route.path == "/zasady-cookies" ||
        this.$route.path == "/ochrana-osobnich-udaju"
      ) {
        return false;
      } else {
        return true;
      }
    },
  },

  created() {
    this.onResize();
    window.addEventListener("resize", this.onResize);
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },

  methods: {
    subIsActive(input) {
      const paths = Array.isArray(input) ? input : [input];
      return paths.some((path) => {
        return this.$route.path.includes(path);
      });
    },
    scrollToElement(elementId) {
      this.$parent.scrollToElement(elementId);
    },
    closeNavbar() {
      var element = document.getElementById("navbarCollapse");
      element.classList.remove("show");
    },
    showCatalogue() {
      this.$router.push({
        path: "/ke-stazeni",
        hash: "#itb-flipbook-title",
      });
    },
    onResize() {
      if (window.innerWidth <= 600) {
        this.isResponsive = true;
      } else {
        this.isResponsive = false;
      }
    },
  },
};
</script>
